import { render } from "./FileInput.vue?vue&type=template&id=748c9ccb&scoped=true&ts=true&lang=pug"
import script from "./FileInput.vue?vue&type=script&lang=ts"
export * from "./FileInput.vue?vue&type=script&lang=ts"

import "./FileInput.vue?vue&type=style&index=0&id=748c9ccb&scoped=true&lang=css"

import exportComponent from "/builds/checkmeru/renova-telemedicine/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-748c9ccb"]])

export default __exports__